/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711499
export const getInfo = createAsyncThunk(
  'UnionTask3/getInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getLevelTarget = createAsyncThunk(
  'UnionTask3/getLevelTarget',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_level_target', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getIncomeTarget = createAsyncThunk(
  'UnionTask3/getIncomeTarget',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_income_target', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 公会收入目标奖励接口
export const getIncomeReward = createAsyncThunk(
  'UnionTask3/getIncomeReward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_income_target_reward',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 公会领取等级目标领取奖励接口
export const levelDraw = createAsyncThunk(
  'UnionTask3/levelDraw',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_level_draw', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 公会领取等级目标领取奖励接口
export const levelWeekGain = createAsyncThunk(
  'UnionTask3/levelWeekGain',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_level_week_target_gain',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 公会收入目标领取奖励接口
export const incomeDraw = createAsyncThunk(
  'UnionTask3/levelDraw',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_income_draw', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 公会等级目标周维度接口
export const getWeekTarget = createAsyncThunk(
  'UnionTask3/getWeekTarget',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_level_week_target',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)
// 1定值金币 2比例金币 3-12 其他类型奖励
export enum RewardType {
  coins = 1,
  multiCoins = 2,
}

// 1待开始 2进行中 3已结束
export enum TaskStatus {
  notStarted = 1,
  processing,
  over,
}
// 0 未完成不可领取 1 可领取 2 已领取 3 未开始
export enum DrawStatus {
  notAvailable = 0,
  available = 1,
  recieved = 2,
  notStarted = 3,
}
export interface IReward {
  type: number
  num: number
  day: number
  pic: string
  desc?: string
  vip: number
}
interface IReward2 {
  pic: string
  desc: string
}
export interface IIncomeTargetInfo {
  id: number
  start_time: string
  end_time: string
  count_down: number
  status: TaskStatus
  target: number
  current: number
  coins: number
  reward: Array<IReward>
  draw_status: DrawStatus
}
export interface ILevelTargetInfo {
  id: number
  target: number
  current: number
  coins: number
  status: DrawStatus
  reward: Array<IReward>
  gain_status?: DrawStatus
}
interface IIncomeReward {
  target: number
  union_desc: Array<IReward2>
  anchor_desc: Array<IReward2>
}

const initialState: {
  union_name: string
  union_id: number
  union_mid: number
  name: string
  avatar: string
  salary: number
  anchors: number
  is_rank: boolean
  is_level_target: boolean
  is_income_target: boolean
  is_income_reward: boolean
  is_level_week_target: boolean
  is_grow: boolean
  count_down: number
  levelList: Array<ILevelTargetInfo>
  incomeList: Array<IIncomeTargetInfo>
  incomeListIndex: number
  incomeRewardList: Array<IIncomeReward>
  weekLevelList: Array<ILevelTargetInfo>
  is_union_leader: boolean
} = {
  union_name: '',
  union_id: 0,
  union_mid: 0,
  name: '',
  avatar: '',
  salary: 0,
  anchors: 0,
  is_rank: false,
  is_level_target: false,
  is_income_target: false,
  is_income_reward: false,
  is_level_week_target: false,
  is_grow: false,
  count_down: 0,
  levelList: [],
  incomeListIndex: 0,
  incomeList: [],
  incomeRewardList: [],
  weekLevelList: [],
  is_union_leader: false,
}

export const UnionTask3Slice = createSlice({
  name: 'UnionTask3',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInfo.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, data)
      })
      .addCase(getLevelTarget.fulfilled, (state, action) => {
        const {data = {}} = action.payload

        state.levelList = data.list || []
      })
      .addCase(getIncomeTarget.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        state.incomeList = data.list || []
        state.incomeListIndex = data.index || 0
      })
      .addCase(getWeekTarget.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        state.weekLevelList = data.list || []
        state.is_union_leader = data.is_union_leader
      })
      .addCase(getIncomeReward.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        state.incomeRewardList = data.list || []
      })
  },
})

export default UnionTask3Slice.reducer
